import styled, { keyframes } from 'styled-components';

const loadingBarAnimation = keyframes`
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
`;

export const LoadingBar = styled.div<{ width?: number }>`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 12px;
  border-radius: 100px;
  background: ${({ theme }) => theme.colors.surface03};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: ${({ width }) => width || 80}px;
    height: 100%;
    border-radius: 100px;
    background: ${({ theme }) => theme.colors.blue};
    animation: ${loadingBarAnimation} 2s linear infinite;
  }
`;
